import React from 'react'
import { Link } from 'react-router-dom'
import KarteraAdminTemplate from '../../../template/KarteraAdminTemplate'
import KarteraPageHeader from '../../../template/kartera/KarteraPageHeader'
import { ChevronRightIcon } from '../../../template/kartera/icons'
import { useSettingsMenuModel } from './settings-menu-model'
import type { SettingsItem } from './settings-menu-model'

const SettingsTile = ({ item, state }: { item: SettingsItem, state: { backUrl: string } }) => (
    <Link
        to={item.to}
        state={state}
        className="group flex min-h-[76px] items-center gap-3.5 rounded-[14px] border border-k-line bg-k-surface px-4 py-3 hover:border-k-line-strong hover:bg-k-hover"
    >
        <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${item.tone}`}>
            <item.Icon style={{ fontSize: 22 }} />
        </span>
        <span className="flex min-w-0 flex-1 flex-col gap-0.5">
            <span className="flex flex-wrap items-center gap-2">
                <span className="text-sm font-bold text-k-ink">{item.label}</span>
                {!item.ready && (
                    <span className="rounded-full bg-k-line-soft px-2 py-0.5 text-[11px] font-bold text-k-muted">Próximamente</span>
                )}
            </span>
            <span className="text-[13px] text-k-muted">{item.description}</span>
        </span>
        <ChevronRightIcon className="shrink-0 text-k-muted-2 group-hover:text-brand-indigo" />
    </Link>
)

const SettingsMenu = () => {
    const model = useSettingsMenuModel()

    return (
        <KarteraAdminTemplate title="Configuración">
            <div className="mx-auto flex w-full max-w-[880px] flex-col gap-[18px]">
                <KarteraPageHeader
                    title="Configuración"
                    description="Administra tu cuenta y las preferencias de tu agencia."
                />

                {model.groups.map((group) => (
                    <section key={group.id} className="k-card">
                        <h2 className="k-card-title">{group.title}</h2>
                        <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                            {group.items.map((item) => (
                                <SettingsTile key={item.to} item={item} state={model.linkState} />
                            ))}
                        </div>
                    </section>
                ))}
            </div>
        </KarteraAdminTemplate>
    )
}

export default SettingsMenu
